import  { RecipesPage } from './pages/RecipesPage'
import  { AddRecipeFromURLPage } from './pages/AddRecipeFromURLPage'
import  { AddRecipeFromTextPage } from './pages/AddRecipeFromTextPage'
import  { AddRecipeFromImagePage } from './pages/AddRecipeFromImagePage'
import  { CreateRecipePage } from './pages/CreateRecipePage'
import  { UpdateRecipePage } from './pages/UpdateRecipePage'
import  { ViewRecipePage } from './pages/ViewRecipePage'
import  { AddToShoppingListPage } from './pages/AddToShoppingListPage'
import  { AddMealLogFromRecipePage } from '@/features/meals/meal-log/pages/AddMealLogFromRecipePage'
import  { recipesImportsRoutes } from './imports/routes'
import { FEATURE_FLAGS } from '@/featureFlags'

export const recipesRoutes = {
  path: 'recipes',
  children: [{
    path: '',
    element: <RecipesPage />,   
    children: [{
      path: 'from-url',
      element: <AddRecipeFromURLPage />,
    }, {
      path: 'from-text',
      element: <AddRecipeFromTextPage />,
    }, {
      path: 'from-image',
      element: <AddRecipeFromImagePage />,
    }]
  }, {
    path: 'create',
    element: <CreateRecipePage />,
  }, {
    path: ':id',
    element: <ViewRecipePage />,
    children: [{
      path: 'add-to-shopping-list',
      element: <AddToShoppingListPage />,
    }, ...(FEATURE_FLAGS.mealTracking ? [{
      path: 'log-meal',
      element: <AddMealLogFromRecipePage />,
    }] : [])],  
  }, {
    path: ':id/edit',
    element: <UpdateRecipePage />,
  },
  recipesImportsRoutes
]};
